'use client';

import { useParams } from 'next/navigation';
import classes from './VerticalCardList.module.scss';
import { Container, Grid } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { Article, Product } from '@/src/types/Header';
import { Title } from '../../Title/Title';
import { VerticalCard } from './VerticalCard/VerticalCard';

export default function VerticalCardList({
  articles,
  products,
  data,
}: {
  articles: Article[];
  products: Product[];
  data: any;
}) {
  const { lang } = useParams();
  useAOS();

  return (
    <section className={classes.section}>
      <Container>
        <Title title={data.title} />
        <Grid>
          {Array.isArray(articles) && articles.length > 0
            ? articles.map((article: any) => (
              <Grid.Col span={{ base: 12, xs: 4 }} key={article.title}>
                <VerticalCard article={article} />
              </Grid.Col>
            ))
            : Array.isArray(products) && products.length > 0
              ? products.map((product: any) => (
                <Grid.Col
                  span={{ base: 12, xs: 4 }}
                  // @ts-ignore
                  key={product.title[lang] ? product.title[lang] : product.title}
                >
                  <VerticalCard product={product} />
                </Grid.Col>
              ))
              : null}
        </Grid>
      </Container>
    </section>
  );
}
